import firebase from '../config/firebase.config';

const database = firebase.firestore();

/**
 * Companies the user belongs to (membersDatabase/{userUID}/companyList).
 */
export async function fetchUserCompanies(userUID) {
  if (!userUID) {
    return { success: true, data: [] };
  }
  try {
    const snapshot = await database
      .collection('membersDatabase')
      .doc(userUID)
      .collection('companyList')
      .get();

    const data = snapshot.docs.map((doc) => {
      const d = doc.data() || {};
      return {
        companyId: doc.id,
        companyName: d.companyName || doc.id,
      };
    });
    return { success: true, data };
  } catch (e) {
    console.error('[fetchUserCompanies]', e);
    return {
      success: false,
      data: [],
      error: e?.message || 'Failed to load companies',
    };
  }
}

/**
 * Teams the user is on for a company (membersDatabase/.../companyList/{companyId}/teamList).
 * Single collection read — avoids N+1 teamDatabase fetches.
 */
export async function fetchUserTeamsForCompany(userUID, companyId) {
  if (!userUID || !companyId) {
    return { success: true, data: [] };
  }
  try {
    const snapshot = await database
      .collection('membersDatabase')
      .doc(userUID)
      .collection('companyList')
      .doc(companyId)
      .collection('teamList')
      .get();

    const teams = [];
    snapshot.forEach((doc) => {
      const teamData = doc.data() || {};
      if (teamData.deleted === true) return;
      teams.push({
        teamId: doc.id,
        teamName: teamData.Team || doc.id,
      });
    });
    return { success: true, data: teams };
  } catch (e) {
    console.error('[fetchUserTeamsForCompany]', e);
    return {
      success: false,
      data: [],
      error: e?.message || 'Failed to load teams',
    };
  }
}

/**
 * Team IDs where the user is a Manager (teamList.Role === 'Manager').
 */
export async function fetchManagedTeamIdsForCompany(userUID, companyId) {
  if (!userUID || !companyId) {
    return { success: true, data: [] };
  }
  try {
    const snapshot = await database
      .collection('membersDatabase')
      .doc(userUID)
      .collection('companyList')
      .doc(companyId)
      .collection('teamList')
      .get();

    const ids = [];
    snapshot.forEach((doc) => {
      const d = doc.data() || {};
      if (d.deleted === true) return;
      if (d.Role === 'Manager') ids.push(doc.id);
    });
    return { success: true, data: ids };
  } catch (e) {
    console.error('[fetchManagedTeamIdsForCompany]', e);
    return {
      success: false,
      data: [],
      error: e?.message || 'Failed to load managed teams',
    };
  }
}
